import React, { useEffect } from "react";
import { createUrl, parseQuery } from "../../../../utils/UrlUtils";
import _ from "lodash";
import FillInFormSortFields from "../../../../constants/chart-sidebar/fillInFormSortFields";
import Show from "../../../widgets/Show";
import ReactSpinner from "react-spinjs-fix";
import { useDispatch } from "react-redux";
import {
  getFrequentlyMedicalFillInFormList,
  getOwnedList,
  openItem,
  loadOwnedList,
  openTextarea,
  setMedicalFillInFormAddendumId,
  copyNoteItem,
  selectSortField,
  getConsultationTemplateList,
  getMedicalFillInFormTemplateQuestions,
  setActiveTab,
  getConsultationTemplatesPrint,
  getMedicalFillInFormHistoryList,
  selectMemberSpecialty,
} from "../../../../actions/chartSideMedicalFillInFormActions";
import medicalFillInFormItemTypes from "../../../../constants/chart-sidebar/medicalFillInFormItemTypes";
import MedicalFillInFormOwnedItem from "./MedicalFillInFormOwnedItem";
import { SET_CONSULTATION_ID } from "../../../../actionTypes/medicalFillInFormActionTypes";
import { openSimpleModal } from "../../../../actions/simpleModalActions";
import { stopLoader } from "../../../../actions/loaderActions";
import { SelectPicker } from "../../../select-picker/SelectPicker";
import { useMemberSpecialtiesListQuery } from "../../../../queries/member/useMemberSpecialtiesListQuery";

const MedicalFillInFormOwnedList = (props) => {
  const dispatch = useDispatch();
  const query = parseQuery(props.location.search);
  const patientKey = _.get(query, "patientKey") || props.patientKey;
  const {
    permissions,
    chartSideMedicalFillInForm: { templateTabList },
  } = props;
  const memberSpecialtiesList = useMemberSpecialtiesListQuery({ isActiveSubSpecialities: true });
  const specialtyData = memberSpecialtiesList?.data || [];

  const isFrequency = () => {
    const query = parseQuery(props.location.search);

    return Boolean(_.get(query, "isFrequency"));
  };

  useEffect(() => {
    if (isFrequency()) {
      dispatch(
        getFrequentlyMedicalFillInFormList({
          patientKey,
        }),
      );
    } else {
      dispatch(getOwnedList({ patientKey }));
    }
  }, []);

  const openItemHandler = (item, mode) => {
    const viewPermission = permissions.indexOf("VIEW_CONSULTATION_NOTE_ITEM") !== -1;
    const { history, location } = props;
    if (!viewPermission) {
      return dispatch(openSimpleModal({ body: "permission denied" }));
    }
    history.replace(
      createUrl(location.pathname, {
        query: {
          ...query,
          medicalType: medicalFillInFormItemTypes.view,
        },
      }),
    );
    const data = { consultationId: item.consultationId, patientKey };
    const mutationFn =
      mode === "print" ? getConsultationTemplatesPrint(data) : getConsultationTemplateList(data);
    dispatch(openItem(item, medicalFillInFormItemTypes[mode]));
    dispatch({ type: SET_CONSULTATION_ID, consultationId: item.consultationId });
    dispatch(mutationFn).then((response) => {
      if (response && response.template) {
        dispatch(
          getMedicalFillInFormHistoryList({
            consultationId: response.consultationId,
            templateId: response.template.id,
            templateTypeId: response.template.templateTypeId,
          }),
        );
      }
    });
  };

  const isEditAvailable = (item) => {
    const less24hours = Date.now() - item.createdDate < 24 * 60 * 60 * 1000;
    const less48hours = Date.now() - item.createdDate < 48 * 60 * 60 * 1000;

    const editAnyTimePermission = permissions.indexOf("MEDICAL_CONSULTATION_EDIT_ANY_TIME") >= 0;
    const less24HourPermission =
      permissions.indexOf("MEDICAL_CONSULTATION_EDIT_WITHIN_24_HOURS") >= 0;
    const less48HourPermission =
      permissions.indexOf("MEDICAL_CONSULTATION_EDIT_WITHIN_48_HOURS") >= 0;
    return (
      editAnyTimePermission ||
      (less48HourPermission && less48hours) ||
      (less24HourPermission && less24hours)
    );
  };
  const onEditHandler = (item) => {
    if (!isEditAvailable(item)) {
      return dispatch(openSimpleModal({ body: "Permission denied" }));
    }
    const { history, location } = props;
    history.replace(
      createUrl(location.pathname, {
        query: {
          ...query,
          medicalType: medicalFillInFormItemTypes.edit,
        },
      }),
    );
    dispatch({ type: SET_CONSULTATION_ID, consultationId: item.consultationId });
    dispatch(getConsultationTemplateList({ consultationId: item.consultationId, patientKey }))
      .then((response) => {
        if ((response || []).length > 0) {
          const item = response[0];
          if (item?.initialExamination) {
            dispatch(setActiveTab(templateTabList[0]));
          }
          dispatch(openItem(item, medicalFillInFormItemTypes.edit));
          const transfer = {
            patientKey: query.patientKey,
            consultationId: item.consultationId,
            templateId: item?.template.id,
          };
          dispatch(getMedicalFillInFormTemplateQuestions(transfer));
        } else {
          if (response?.initialExamination) {
            dispatch(setActiveTab(templateTabList[0]));
          }
          dispatch(openItem(response, medicalFillInFormItemTypes.edit));
        }
      })
      .catch((error) => {
        dispatch(stopLoader(error));
      });
  };

  const loadList = (e) => {
    const scrollBottom = e.target.scrollTop + e.target.offsetHeight + 1 >= e.target.scrollHeight;

    if (scrollBottom) {
      dispatch(loadOwnedList({ patientKey: props.patientKey }));
    }
  };

  const select = (event) => {
    dispatch(selectSortField(event.target.value));
  };

  const onSpecialtyChange = (specialty) => {
    dispatch(selectMemberSpecialty(specialty));
  };

  const openTextareaHandler = () => {
    dispatch(openTextarea(true));
  };

  const openAddendum = (id) => {
    dispatch(setMedicalFillInFormAddendumId(id));
    openTextareaHandler();
  };

  const {
    ownedList,
    fetching,
    sortField,
    frequencyList,
    consultationId,
    historicalListCount,
    memberSpecialties,
  } = props.chartSideMedicalFillInForm;

  const targetList = isFrequency() ? frequencyList : ownedList;

  let $list = targetList.map((item, index) => (
    <MedicalFillInFormOwnedItem
      key={index}
      item={item}
      consultationId={consultationId}
      openItem={openItemHandler}
      editItem={onEditHandler}
      openAddendumItem={() => {
        openAddendum(item.consultationId);
      }}
      onReferenceClick={(id) => {
        dispatch(openItem({ id }, medicalFillInFormItemTypes.view));
      }}
      copyItem={() => dispatch(copyNoteItem(item.id))}
    />
  ));

  const $options = FillInFormSortFields.map((item, index) => (
    <option key={index} value={item.code}>
      {item.name}
    </option>
  ));

  const specialtyOptions = specialtyData.map((item) => ({
    label: item.name,
    value: item.id,
  }));

  return (
    <div className="chart-clinical-note" style={{ height: "100%" }}>
      <div className="d-flex justify-content-between col-gap-2">
        <div className="chart-clinical-note-select pl-0 pr-0 w-100">
          <select onChange={select} value={sortField} className="form-control">
            {$options}
          </select>
        </div>
        <div className="chart-clinical-note-select pl-0 pr-0 w-100 position-relative">
          <SelectPicker
            isMulti={true}
            options={specialtyOptions}
            value={memberSpecialties}
            placeholder="Select Specialty"
            onChange={(value) => onSpecialtyChange(value)}
          />
        </div>
      </div>
      <div className="chart-side-body">
        <div
          className="body dental-data-list"
          style={{ overflowY: "auto", height: "100%" }}
          onScroll={loadList}
        >
          {$list}
          <Show if={historicalListCount === 0 && _.isEmpty($list)}>
            <span className="text-center font-weight-bold mt-1">No historical consultations</span>
          </Show>
          <Show if={fetching}>
            <ReactSpinner />
          </Show>
        </div>
      </div>
    </div>
  );
};

export default MedicalFillInFormOwnedList;
